import { supabase } from '@/integrations/supabase/client';
import { Task } from '@/types/tasks';

/**
 * Simple task database update function (no React Query)
 * Similar to workbook and storage systems
 */
export async function updateTaskInDatabase(
  taskId: string,
  updates: Partial<Task>
): Promise<void> {
  // Convert UI task updates to DB task updates
  const dbUpdates: any = {};
  
  if (updates.title !== undefined) dbUpdates.title = updates.title;
  if (updates.description !== undefined) dbUpdates.description = updates.description ?? null;
  if (updates.dueDate !== undefined) dbUpdates.due_date = updates.dueDate ?? null;
  if (updates.priority !== undefined) dbUpdates.priority = updates.priority ?? null;
  if (updates.isCompleted !== undefined) dbUpdates.is_completed = updates.isCompleted;
  if (updates.cardOrder !== undefined) dbUpdates.card_order = updates.cardOrder;
  if (updates.goalId !== undefined) dbUpdates.goal_id = updates.goalId ?? null;
  
  const { error } = await supabase
    .from('planner_tasks')
    .update(dbUpdates)
    .eq('id', taskId);

  if (error) {
    console.error('Failed to update task in database:', error);
    throw new Error(`Failed to update task: ${error.message}`);
  }
}